import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
    FaTools,
    FaTruck,
    FaTree,
    FaCogs,
    FaMusic,
    FaBug,
    FaChevronLeft, // Ícone para navegação do slider
    FaChevronRight  // Ícone para navegação do slider
} from 'react-icons/fa';
import '../../../assets/css/reformapianos.css'; // Mantenha este caminho para o CSS

// Dados para múltiplos exemplos de Antes/Depois
const reformImagesData = [
    { id: 1, antes: '/img/ad/antes.webp', depois: '/img/ad/depois.webp', alt: '100% reformado' },
    { id: 2, antes: '/img/ad/antes1.webp', depois: '/img/ad/depois1.webp', alt: '100% reformado' },
    { id: 3, antes: '/img/ad/antes2.webp', depois: '/img/ad/depois2.webp', alt: '100% reformado' },
    { id: 4, antes: '/img/ad/antes3.webp', depois: '/img/ad/depois3.webp', alt: '100% reformado' },
];

const ReformaDePianos = () => {
    // State para controlar o índice da imagem atual no slider
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    // State para alternar entre "antes" e "depois" da imagem atual do slider
    const [imageState, setImageState] = useState('before'); // 'before' ou 'after'

    // Estado ÚNICO para controlar a expansão/encurtamento de AMBOS os textos
    const [isTextExpanded, setIsTextExpanded] = useState(false);

    // Textos originais, conforme solicitado
    const classicTextOriginal = "Reforma de pianos é a Especialidade da casa. Profundo conhecimento técnico na restauração do móvel e teclado, revisão e ajustes no mecanismo, sistema de encordoamento e transporte.";
    const modernTextOriginal = "Somos especializados na parte do móvel do piano realizando trabalhos de encher os olhos dos mais exigentes clientes. Além do aspecto visual, reformando conosco, você terá um piano totalmente restaurado contando com:";

    const features = [
        { icon: <FaTruck className="feature-icon" />, text: "Transporte especializado (retirada e entrega)" },
        { icon: <FaTree className="feature-icon" />, text: "Restauração impecável do móvel do piano a partir da madeira natural" },
        { icon: <FaTools className="feature-icon" />, text: "Correção de imperfeições, aplicação de bases e vernizes" },
        { icon: <FaCogs className="feature-icon" />, text: "Revisão técnica geral no mecanismo" },
        { icon: <FaMusic className="feature-icon" />, text: "Serviços de regulagem do maquinário, teclado e afinação" },
        { icon: <FaBug className="feature-icon" />, text: "Eliminação de cupins" }
    ];

    // Funções para navegação do slider
    const nextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            (prevIndex + 1) % reformImagesData.length
        );
        setImageState('after'); // Reseta para 'depois' ao mudar de imagem
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            (prevIndex - 1 + reformImagesData.length) % reformImagesData.length
        );
        setImageState('after'); // Reseta para 'depois' ao mudar de imagem
    };

    // Imagem atualmente selecionada pelo slider
    const currentImage = reformImagesData[currentImageIndex];

    return (
        <div className="container-reforma-pianos">
            {/* Seção da Imagem (Lado Esquerdo) */}
            <motion.div
                className="piano-image-section"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="piano-image-container-re">
                    {/* Imagem atual do slider (antes ou depois) */}
                    <img
                        // O src usa a imagem 'antes' ou 'depois' do objeto 'currentImage'
                        src={imageState === 'before' ? currentImage.antes : currentImage.depois}
                        alt={`Piano ${currentImage.alt} ${imageState === 'before' ? 'antes' : 'depois'} da reforma`}
                        className="piano-image"
                    />

                    {/* Botões Antes/Depois para a imagem atual */}
                    <div className="piano-image-before-after">
                        <button
                            className={`before-after-btn ${imageState === 'before' ? 'active' : ''}`}
                            onClick={() => setImageState('before')}
                        >
                            Antes
                        </button>
                        <button
                            className={`before-after-btn ${imageState === 'after' ? 'active' : ''}`}
                            onClick={() => setImageState('after')}
                        >
                            Depois
                        </button>
                    </div>

                    {/* Controles do Slider (Próxima/Anterior Imagem) */}
                    <div className="slider-nav-arrows">
                        <button onClick={prevImage} className="slider-arrow">
                            <FaChevronLeft />
                        </button>
                        <button onClick={nextImage} className="slider-arrow">
                            <FaChevronRight />
                        </button>
                    </div>
                </div>
            </motion.div>

            {/* Seção de Texto (Lado Direito) */}
            <motion.div
                className="piano-text-section"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
            >
                <h2 className="section-title">Reforma de Pianos</h2>

                {/* Wrapper para os textos e o botão "Leia Mais/Ver Menos" */}
                {/* A classe 'text-container-mobile' e 'expanded' serão usadas pelo CSS para o truncamento */}
                <div className={`text-container-mobile ${isTextExpanded ? 'expanded' : ''}`}>
                    {/* Texto Clássico */}
                    <motion.p
                        className="classic-text"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                    >
                        {classicTextOriginal}
                    </motion.p>

                    {/* Texto Moderno */}
                    <motion.p
                        className="modern-text"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6 }}
                    >
                        {modernTextOriginal}
                    </motion.p>

                                  {/* Lista de Recursos */}
                <motion.ul
                    className="features-list"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                >
                    {features.map((feature, index) => (
                        <motion.li
                            key={index}
                            className="feature-item animated-item"
                            // Atraso de animação para itens de lista
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.9 + index * 0.1, duration: 0.3 }}
                        >
                            {feature.icon}
                            <span className="feature-text">{feature.text}</span>
                        </motion.li>
                    ))}
                </motion.ul>
                </div>

                {/* Botão "Leia Mais/Ver Menos" visível SOMENTE no celular */}
                <button
                    className="read-more-button"
                    onClick={() => setIsTextExpanded(!isTextExpanded)}
                >
                    {isTextExpanded ? 'Ver Menos' : 'Leia Mais'}
                </button>

  
            </motion.div>
        </div>
    );
};

export default ReformaDePianos;